module.exports = __webpack_public_path__ + "img/scrolldown.19539306.svg";